const bdStatsID = '1cdd23dd21f42d1731f66b692671b6c1'
/**
 * 百度统计
 */
export default ({ app: { router }, store }) => {
    router.afterEach((to, from) => {
        if (process.client && process.env.NODE_ENV === 'production') {
            var _hmt = _hmt || []
            ;(function() {
                const hm = document.createElement('script')
                hm.src = `https://hm.baidu.com/hm.js?${bdStatsID}`
                hm.async = true
                const s = document.getElementsByTagName('script')[0]
                s.parentNode.insertBefore(hm, s)
            })()
        }
    })
}
